import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPexelsComponent } from './simple-icons-pexels.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPexelsComponent ],
    exports:      [ SimpleIconsPexelsComponent ],
    bootstrap:    []
})
export class SimpleIconsPexelsModule {}
